import PerfectScrollbar from 'perfect-scrollbar';

$(document).ready(function() {

    var ps;

    if($('.js-scroll-notice').height() > 0) {
    	ps = new PerfectScrollbar('.js-scroll-notice', {
			wheelSpeed:0.1,
			wheelPropagation: true,
			minScrollbarLength:180,
			maxScrollbarLength:180,
		});
    }

    if ($(".js-scroll-notice .ps__thumb-y").height() == 0) {
    	$(".js-scroll-notice").addClass("hide-scroll");
    }
});


// WEBPACK FOOTER //
// ./src/js/pages/notice/notice-scroll.js